<template>
  <div>
    <img v-if="icon === 'BRL'" :src="pathFlagBrazil" :class="[`w-${size}`, ...classess]">

    <i
      v-else
      :class="[icon, `text-${size}xl` , ...classess]"
      :style="{ color }"
    />
  </div>
</template>

<script>
import "cryptocoins-icons/webfont/cryptocoins.css";

export default {
  props: {
    icon: { type: String, required: true },
    color: { type: String, required: true },
    size: { type: String, default: '4' },
    otherClass: { type: String, default: '' }
  },
  data() {
    return {
      pathFlagBrazil: '../../../images/flag_brazil_rounded.png',
    }
  },
  computed: {
    classess() {
      return this.otherClass.split(' ')
    }
  }
};
</script>

<style>
  .usdc{
    display: flex;
  }
  .usdc::before {
    content: url('https://api.iconify.design/cryptocurrency/usdc.svg?color=%232772cb&width=18');
    display: inline-flex;
  }

  .usdc.text-2xl::before {
    content: url('https://api.iconify.design/cryptocurrency/usdc.svg?color=%232772cb&width=24');
    display: inline-flex;
  }

  .usdc.text-3xl::before {
    content: url('https://api.iconify.design/cryptocurrency/usdc.svg?color=%232772cb&width=30');
    display: inline-flex;
  }

  .usdc.text-4xl::before {
    content: url('https://api.iconify.design/cryptocurrency/usdc.svg?color=%232772cb&width=36');
    display: inline-flex;
  }

  .usdc.text-5xl::before {
    content: url('https://api.iconify.design/cryptocurrency/usdc.svg?color=%232772cb&width=48');
    display: inline-flex;
  }
</style>
